import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navigation-buttons d-flex justify-content-center gap-3 mt-4 mb-3" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-secondary",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args))),
      disabled: _ctx.isFirstStep
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1)
    ]), 8, _hoisted_2),
    _createElementVNode("button", {
      class: "btn btn-primary",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args))),
      disabled: _ctx.isLastStep
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1)
    ]), 8, _hoisted_3)
  ]))
}